export default __webpack_public_path__ + "static/media/cont14.7ebea439.png";